import React from 'react';
import Container from '@mui/material/Container';

export interface LzPContainer {
    children?: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    noGutters?: boolean;
}

export default function LzXContainer(props: LzPContainer) {
    return (
        <Container className={'lz-container ' + (props.className || '')} style={props.style} disableGutters={props.noGutters}>
            {props.children}
        </Container>
    );
}
